import { render } from "./AwakersMobile.vue?vue&type=template&id=54e3ab64&scoped=true"
const script = {}

import "./AwakersMobile.vue?vue&type=style&index=0&id=54e3ab64&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e3ab64"]])

export default __exports__